import { render, staticRenderFns } from "./eg_rubric_card.vue?vue&type=template&id=8c38b032&scoped=true&"
import script from "./eg_rubric_card.vue?vue&type=script&lang=js&"
export * from "./eg_rubric_card.vue?vue&type=script&lang=js&"
import style0 from "./eg_rubric_card.vue?vue&type=style&index=0&id=8c38b032&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c38b032",
  null
  
)

export default component.exports